// extracted by mini-css-extract-plugin
export default {"container":"O8-z","productName":"P8-z","price":"Q8-z","dimensions":"R8-z"};